// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, flatMap, tap } from 'rxjs/operators';
import { LoggedUserActionType, LoggedUserLoadComplete, LoggedUserFailed, LoggedUserLoading } from '.';
import { of } from 'rxjs';
import { UserService } from '../../services/user.service';
import { AuthActionTypes } from '../auth.actions';

@Injectable()
export class LoggedUserEffects {
  @Effect()
  requestOnLoadGroups$ = this.actions$.pipe(
    ofType(LoggedUserActionType.LOGGED_USER_LOADING),
    switchMap(() => this.request())
  );

  @Effect()
  loadLoggedUser$ = this.actions$.pipe(
    ofType(AuthActionTypes.LOGIN),
    flatMap(() => of(new LoggedUserLoading()))
  );

  constructor(private actions$: Actions, private userService: UserService) {}

  private request() {
    return this.userService.getUser().pipe(
        map((response: any) => new LoggedUserLoadComplete(response)),
        catchError(() => of(new LoggedUserFailed()))
    );
  }
}





// WEBPACK FOOTER //
// ./src/app/core/state/logged-user/logged-user.effect.ts